





































import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/headerTitle.vue";
import QUILL from "./components/QUILL/index.vue";
import { filterData } from "@/config/filterData";
import {
  apiBanConfSwitch,
  BanConfSwitchProps,
  apiChargeRuleSave,
  apiChargeRuleDel,
} from "./service";
import Quill from "quill";
const fontSizeStyle = Quill.import("attributors/style/size");
fontSizeStyle.whitelist = [
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "24px",
];
Quill.register(fontSizeStyle, true);
@Component({
  components: { headerTitle, QUILL },
})
export default class Home extends Vue {
  public ruleList: BanConfSwitchProps[] = [];
  public filterData = filterData;
  public mounted() {
    this.init();
  }
  public async init() {
    const res = await apiBanConfSwitch();
    if (res.code === 0) {
      this.ruleList = res.data;
    }
  }
  public async submit() {
    const arr = JSON.parse(JSON.stringify(this.ruleList)).filter(
      (item) => item.value !== ""
    );
    const res = await apiChargeRuleSave({
      rule: JSON.stringify(arr),
    });
    if (res.code === 0) {
      this.$Message.success(res.msg);
      this.init();
    }
  }
  public delClick(index) {
    this.$Modal.confirm({
      content: "确定要删除该规则吗？",
      onOk: async () => {
        if (this.ruleList[index].id) {
          const res = await apiChargeRuleDel({
            id: this.ruleList[index].id,
          });
          if (res.code === 0) {
            this.ruleList.splice(index, 1);
            this.$Message.success("成功删除");
          }
        } else {
          this.ruleList.splice(index, 1);
          this.$Message.success("成功删除");
        }
      },
    });
  }
  public addClick() {
    this.ruleList.push({ name: "", value: "" });
  }
}
